/* eslint-disable */
const hash = {
  "en-US": "a88b0fa2",
  "de-DE": "94016456",
  "es-ES": "75b05ca8",
  "fr-FR": "a7bcc329",
  "id-ID": "16ceff78",
  "it-IT": "a6b5167c",
  "jp-JP": "5242daa7",
  "ko-KO": "482a94b2",
  "nl-NL": "3abd7043",
  "pl-PL": "0b03360b",
  "pt-PT": "29e77b27",
  "ru-RU": "0b80563d",
  "sv-SE": "ec9e46da",
  "tr-TR": "9e89b6fa",
  "vi-VN": "0147e354",
  "zh-CN": "ce05948b",
  "zh-TW": "bbc4ddb2",
  "control": "7a156636",
  "plan-details": "3757e783",
  "gov-EN": "96739e64",
  "en-GB": "7ccf8829"
}
export default hash
